import React from 'react';
import { MessageCircle } from 'lucide-react';
import { buildWhatsAppUrl } from '@/utils/format';

const WhatsAppButton = ({ message = 'Hola, me interesa recibir asesoría sobre alimentos para mi mascota' }) => {
  return (
    <a
      href={buildWhatsAppUrl(message)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contactar por WhatsApp"
      data-testid="whatsapp-float-button"
      className="wa-float fixed bottom-4 left-4 sm:left-auto sm:bottom-6 sm:right-6 z-40 w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-[#25D366] hover:bg-[#20BD5A] flex items-center justify-center shadow-lg whatsapp-pulse"
    >
      <MessageCircle className="w-6 h-6 sm:w-7 sm:h-7 text-white" fill="white" />
    </a>
  );
};

export default WhatsAppButton;
